// Motor de recomendaciones curado (sin IA/LLM en la app)

export const BUSINESS_TYPES = [
  { id: "restaurant", label: "Restaurante / Café", icon: "UtensilsCrossed" },
  { id: "salon", label: "Salón / Spa", icon: "Scissors" },
  { id: "freelancer", label: "Freelancer / Autónomo", icon: "Laptop" },
  { id: "retail", label: "Tienda / Comercio", icon: "ShoppingBag" },
  { id: "services", label: "Servicios a domicilio", icon: "Wrench" },
  { id: "other", label: "Otra cosa", icon: "Building2" },
];

export const PAIN_POINTS = [
  {
    id: "calls",
    label: "Atender llamadas de clientes",
    icon: "PhoneCall",
    plain: "Demasiadas llamadas, clientes perdidos y repetir lo mismo mil veces.",
    manualMinutes: 90, // por día
    aiMinutes: 15,
  },
  {
    id: "scheduling",
    label: "Reservas y agenda",
    icon: "CalendarClock",
    plain: "Ir y venir de mensajes para cuadrar citas y recordatorios.",
    manualMinutes: 70,
    aiMinutes: 10,
  },
  {
    id: "invoicing",
    label: "Facturación y cobros",
    icon: "ReceiptText",
    plain: "Crear facturas, perseguir pagos y saber quién ya pagó.",
    manualMinutes: 60,
    aiMinutes: 12,
  },
  {
    id: "social",
    label: "Redes sociales y marketing",
    icon: "Megaphone",
    plain: "Pensar publicaciones, textos y mantener la constancia.",
    manualMinutes: 75,
    aiMinutes: 18,
  },
];

// Herramientas por dolor. El tiempo ahorrado es en horas/semana.
export const TOOL_RECOMMENDATIONS = {
  calls: [
    {
      name: "Goodcall — Recepcionista IA",
      tagline: "Un asistente de voz con IA que contesta TODAS tus llamadas por ti, 24/7.",
      provider: "Goodcall",
      monthlyCost: 59,
      timeSavedPerWeek: 7,
      difficulty: "Fácil",
      setupMinutes: 20,
      url: "https://www.goodcall.com/",
      autonomous: true,
      autonomyNote:
        "La IA contesta, responde preguntas frecuentes, toma mensajes y agenda sin que tú intervengas.",
      steps: [
        "Regístrate y elige un número (o desvía el tuyo actual).",
        "Responde unas preguntas sencillas sobre tus horarios, menú y ubicación.",
        "Goodcall crea un agente de IA que contesta, toma mensajes y reserva.",
        "Actívalo para fuera de horario o todo el día — tú solo revisas los mensajes.",
      ],
    },
    {
      name: "Retell AI — Agente de voz autónomo",
      tagline: "Un agente de voz con IA que habla con tus clientes como una persona y opera solo.",
      provider: "Retell AI",
      monthlyCost: 49,
      timeSavedPerWeek: 8,
      difficulty: "Media",
      setupMinutes: 40,
      url: "https://www.retellai.com/",
      autonomous: true,
      autonomyNote:
        "Configuras qué debe hacer (agendar, dar info, filtrar) y el agente atiende llamadas de forma autónoma.",
      steps: [
        "Crea una cuenta y conecta un número de teléfono.",
        "Describe en lenguaje normal qué debe hacer el agente.",
        "Conecta tu agenda o tu sistema de reservas.",
        "Activa el agente: atiende y resuelve llamadas por sí solo.",
      ],
    },
    {
      name: "ChatGPT — Guiones y respuestas",
      tagline: "Escribe respuestas amables a las preguntas que oyes todo el día.",
      provider: "OpenAI",
      monthlyCost: 20,
      timeSavedPerWeek: 2,
      difficulty: "Muy fácil",
      setupMinutes: 10,
      url: "https://chat.openai.com/",
      autonomous: false,
      autonomyNote: "Te ayuda a preparar contenido; tú decides cuándo usarlo.",
      steps: [
        "Crea una cuenta gratuita de ChatGPT.",
        "Escribe: 'Dame 5 respuestas cortas de teléfono para una pizzería con mucho movimiento.'",
        "Copia las respuestas junto al teléfono o compártelas con tu equipo.",
        "Actualízalas cuando cambien tus precios u horarios.",
      ],
    },
    {
      name: "Bland AI — Llamadas con IA",
      tagline: "Un agente telefónico con IA que hace y recibe llamadas por ti, a cualquier hora.",
      provider: "Bland AI",
      monthlyCost: 39,
      timeSavedPerWeek: 7,
      difficulty: "Media",
      setupMinutes: 45,
      url: "https://www.bland.ai/",
      autonomous: true,
      autonomyNote:
        "Le dices qué debe decir y hacer; el agente llama, confirma citas y responde solo.",
      steps: [
        "Crea una cuenta en Bland AI.",
        "Describe el guion y el objetivo de la llamada en lenguaje normal.",
        "Conecta tu número y tu agenda o CRM.",
        "Activa el agente: gestiona las llamadas de forma autónoma.",
      ],
    },
    {
      name: "Synthflow — Recepción por voz IA",
      tagline: "Recepcionista de voz con IA, sin código, que atiende y agenda sola.",
      provider: "Synthflow",
      monthlyCost: 29,
      timeSavedPerWeek: 6,
      difficulty: "Fácil",
      setupMinutes: 30,
      url: "https://synthflow.ai/",
      autonomous: true,
      autonomyNote:
        "Montas el asistente arrastrando bloques y atiende llamadas 24/7 sin que intervengas.",
      steps: [
        "Regístrate en Synthflow.",
        "Elige una plantilla de recepcionista y personalízala.",
        "Conecta tu número y calendario.",
        "Publícalo: contesta y agenda de forma autónoma.",
      ],
    },
  ],
  scheduling: [
    {
      name: "Calendly",
      tagline: "Comparte un enlace y los clientes reservan solos, sin ir y venir de mensajes.",
      provider: "Calendly",
      monthlyCost: 12,
      timeSavedPerWeek: 5,
      difficulty: "Muy fácil",
      setupMinutes: 15,
      url: "https://calendly.com/",
      autonomous: true,
      autonomyNote:
        "Muestra tu disponibilidad y agenda automáticamente, con recordatorios enviados solos.",
      steps: [
        "Crea una cuenta gratis y conecta tu calendario.",
        "Define tus horarios y la duración de las citas.",
        "Comparte tu enlace en tu web, mensajes y la bio de Instagram.",
        "El cliente elige un hueco; se agrega solo a tu calendario con recordatorio.",
      ],
    },
    {
      name: "Square Appointments",
      tagline: "Reservas + recordatorios gratis, pensado para salones y tiendas.",
      provider: "Square",
      monthlyCost: 0,
      timeSavedPerWeek: 4,
      difficulty: "Fácil",
      setupMinutes: 25,
      url: "https://squareup.com/us/en/appointments",
      autonomous: true,
      autonomyNote: "Envía confirmaciones y recordatorios automáticos por SMS y correo.",
      steps: [
        "Regístrate gratis en Square Appointments.",
        "Añade tus servicios, precios y personal.",
        "Activa los recordatorios automáticos por SMS y correo.",
        "Comparte tu página de reservas — bajan las ausencias al instante.",
      ],
    },
    {
      name: "Make.com — Recordatorios automáticos",
      tagline: "La IA envía confirmaciones y recordatorios solos cada vez que alguien reserva.",
      provider: "Make",
      monthlyCost: 16,
      timeSavedPerWeek: 3,
      difficulty: "Media",
      setupMinutes: 30,
      url: "https://www.make.com/",
      autonomous: true,
      autonomyNote:
        "Creas un flujo una vez y se ejecuta solo ante cada nueva reserva, sin tocar nada.",
      steps: [
        "Crea una cuenta en Make.",
        "Elige el disparador: 'Cuando se crea una reserva'.",
        "Añade la acción: 'Enviar recordatorio por SMS o correo'.",
        "Actívalo — los recordatorios se envían solos de ahora en adelante.",
      ],
    },
    {
      name: "Zapier Agents — Asistente autónomo",
      tagline: "Agentes de IA que gestionan reservas y respuestas por ti, sin tocar nada.",
      provider: "Zapier",
      monthlyCost: 30,
      timeSavedPerWeek: 4,
      difficulty: "Media",
      setupMinutes: 35,
      url: "https://zapier.com/agents",
      autonomous: true,
      autonomyNote:
        "Le describes la tarea (confirmar, reprogramar, avisar) y el agente la ejecuta solo.",
      steps: [
        "Entra en Zapier Agents y crea un agente.",
        "Explica en lenguaje normal qué debe hacer con las reservas.",
        "Conecta tu calendario y tu correo o SMS.",
        "Actívalo: gestiona la agenda de forma autónoma.",
      ],
    },
  ],
  invoicing: [
    {
      name: "QuickBooks",
      tagline: "Envía facturas profesionales y cobra más rápido.",
      provider: "Intuit",
      monthlyCost: 30,
      timeSavedPerWeek: 4,
      difficulty: "Fácil",
      setupMinutes: 25,
      url: "https://quickbooks.intuit.com/",
      autonomous: true,
      autonomyNote: "Recuerda automáticamente a quienes pagan tarde y registra los pagos solo.",
      steps: [
        "Regístrate y añade el nombre y logo de tu negocio.",
        "Crea una plantilla de factura una sola vez.",
        "Envía facturas por correo con un botón 'Pagar ahora'.",
        "QuickBooks recuerda solo a los que se retrasan en pagar.",
      ],
    },
    {
      name: "Wave (Facturación gratis)",
      tagline: "Facturación y seguimiento de pagos totalmente gratis.",
      provider: "Wave",
      monthlyCost: 0,
      timeSavedPerWeek: 3,
      difficulty: "Muy fácil",
      setupMinutes: 15,
      url: "https://www.waveapps.com/",
      autonomous: false,
      autonomyNote: "Automatiza el envío, pero tú generas la factura cuando quieras.",
      steps: [
        "Crea una cuenta gratis en Wave.",
        "Añade tus clientes y servicios.",
        "Envía una factura en menos de un minuto.",
        "Mira de un vistazo quién pagó y quién no.",
      ],
    },
    {
      name: "Zapier — Facturación automática",
      tagline: "Convierte trabajos terminados en facturas de forma automática.",
      provider: "Zapier",
      monthlyCost: 20,
      timeSavedPerWeek: 3,
      difficulty: "Media",
      setupMinutes: 35,
      url: "https://zapier.com/",
      autonomous: true,
      autonomyNote:
        "En cuanto marcas un trabajo como terminado, crea y envía la factura sin que hagas nada.",
      steps: [
        "Conecta tu app de reservas o tu hoja de cálculo a Zapier.",
        "Disparador: 'Cuando un trabajo se marca como completado'.",
        "Acción: 'Crear y enviar una factura'.",
        "Las facturas salen solas en cuanto termina un trabajo.",
      ],
    },
    {
      name: "Bill.com — Cobros con IA",
      tagline: "La IA registra facturas, programa pagos y persigue cobros por ti.",
      provider: "Bill.com",
      monthlyCost: 45,
      timeSavedPerWeek: 4,
      difficulty: "Media",
      setupMinutes: 40,
      url: "https://www.bill.com/",
      autonomous: true,
      autonomyNote:
        "Lee y captura facturas automáticamente y envía recordatorios de pago sin que hagas nada.",
      steps: [
        "Crea una cuenta en Bill.com.",
        "Conecta tu banco y tu contabilidad.",
        "Sube o reenvía tus facturas — la IA las captura sola.",
        "Programa aprobaciones y pagos automáticos.",
      ],
    },
  ],
  social: [
    {
      name: "ChatGPT — Textos y publicaciones",
      tagline: "Genera una semana entera de publicaciones y textos en minutos.",
      provider: "OpenAI",
      monthlyCost: 20,
      timeSavedPerWeek: 5,
      difficulty: "Muy fácil",
      setupMinutes: 10,
      url: "https://chat.openai.com/",
      autonomous: false,
      autonomyNote: "Crea el contenido; tú eliges qué publicar.",
      steps: [
        "Crea una cuenta de ChatGPT.",
        "Escribe: 'Dame 7 textos de Instagram para mi salón esta semana.'",
        "Elige tus favoritos y ajusta las palabras.",
        "Publícalos o prográmalos con una herramienta como Buffer.",
      ],
    },
    {
      name: "Ocoya — Publicación autónoma",
      tagline: "La IA crea, programa y publica sola en todas tus redes.",
      provider: "Ocoya",
      monthlyCost: 19,
      timeSavedPerWeek: 5,
      difficulty: "Fácil",
      setupMinutes: 25,
      url: "https://www.ocoya.com/",
      autonomous: true,
      autonomyNote:
        "Genera textos e imágenes con IA y publica automáticamente en los mejores horarios.",
      steps: [
        "Crea una cuenta y conecta tus redes sociales.",
        "Deja que la IA genere textos e imágenes por ti.",
        "Programa contenido para semanas de una sola vez.",
        "Ocoya publica solo en los mejores horarios.",
      ],
    },
    {
      name: "Canva Magic Studio",
      tagline: "Diseña publicaciones y deja que la IA escriba y las ajuste por ti.",
      provider: "Canva",
      monthlyCost: 15,
      timeSavedPerWeek: 4,
      difficulty: "Fácil",
      setupMinutes: 20,
      url: "https://www.canva.com/",
      autonomous: false,
      autonomyNote: "Acelera el diseño con IA; tú das el visto bueno final.",
      steps: [
        "Regístrate en Canva (el plan gratis sirve para empezar).",
        "Elige una plantilla de redes para tu negocio.",
        "Usa 'Magic Write' para rellenar el texto automáticamente.",
        "Descarga o programa tu publicación terminada.",
      ],
    },
    {
      name: "ManyChat — Chatbot autónomo",
      tagline: "Un chatbot con IA que responde en Instagram y WhatsApp por ti, 24/7.",
      provider: "ManyChat",
      monthlyCost: 15,
      timeSavedPerWeek: 5,
      difficulty: "Fácil",
      setupMinutes: 25,
      url: "https://manychat.com/",
      autonomous: true,
      autonomyNote:
        "Responde mensajes, preguntas frecuentes y captura clientes automáticamente en tus redes.",
      steps: [
        "Crea una cuenta y conecta Instagram/WhatsApp.",
        "Elige una plantilla de respuestas automáticas.",
        "Añade tus preguntas frecuentes y ofertas.",
        "Actívalo: responde y capta clientes de forma autónoma.",
      ],
    },
    {
      name: "Jasper — Redactor con IA",
      tagline: "Genera campañas, textos y anuncios de marketing con la voz de tu marca.",
      provider: "Jasper",
      monthlyCost: 49,
      timeSavedPerWeek: 4,
      difficulty: "Fácil",
      setupMinutes: 20,
      url: "https://www.jasper.ai/",
      autonomous: false,
      autonomyNote: "Crea el contenido de marketing a tu estilo; tú apruebas y publicas.",
      steps: [
        "Regístrate en Jasper.",
        "Define la voz y el tono de tu marca.",
        "Pide campañas, textos o anuncios completos.",
        "Ajusta y publica en tus canales.",
      ],
    },
  ],
};

export const SUCCESS_STORIES = [
  {
    name: "Pizzería de Joe",
    person: "Joe, Dueño",
    type: "Restaurante",
    quote:
      "El asistente telefónico con IA ya toma 20 pedidos al día. Dejé de perder llamadas en la hora pico y recuperé 8 horas a la semana.",
    hoursSaved: 8,
    metric: "20 pedidos/día automatizados",
    image:
      "https://images.unsplash.com/photo-1758519289791-ffce8889ca8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxyZXN0YXVyYW50JTIwb3duZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODMzODI5MzN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Bloom Estudio de Belleza",
    person: "María, Gerente del salón",
    type: "Salón",
    quote:
      "Ahora los clientes reservan solos. Las ausencias bajaron a la mitad gracias a los recordatorios automáticos por SMS. Funciona solo.",
    hoursSaved: 6,
    metric: "50% menos ausencias",
    image:
      "https://images.pexels.com/photos/26759527/pexels-photo-26759527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Dev & Design Co.",
    person: "Sam, Freelancer",
    type: "Freelancer",
    quote:
      "Las facturas se envían solas al terminar un proyecto. Cobro más rápido y hace meses que no persigo un pago atrasado.",
    hoursSaved: 5,
    metric: "Cobros 2x más rápidos",
    image:
      "https://images.unsplash.com/photo-1765648636118-6d1eaaeb669f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxmcmVlbGFuY2VyJTIwd29ya2luZyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MzM4MjkzM3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const DEFAULT_HOURLY_RATE = 30;
